import { setLoadingConfigObject } from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import styles from './SettingsLoading.Styles';

const headerLoadingConfig = [
  {
    left: setLoadingConfigObject('line', 1, 166, styles.firstLine),
  },
  {
    left: setLoadingConfigObject('line', 1, 215, styles.secondLine),
  },
];

const settingsCardLoadingConfig = [
  {
    left: setLoadingConfigObject('circle', 1, null, styles.settingsCardBodyItemCircle),
    main: [
      setLoadingConfigObject('square', 1, null, styles.settingsCardBodyItemSquare),
      setLoadingConfigObject('square', 1, null, styles.settingsCardBodyItemSecondSquare),
    ],
  },
];

export { headerLoadingConfig, settingsCardLoadingConfig };
